import axios from "axios";
import { Dialog } from 'antd-mobile';
// 根据环境不同引入不同api地址
import { APPID, version, channel } from "../config/index";

import { getStrFun } from "./util";
import { getClientAuthToken, promptLoginFailReload } from "./authStorage";

// create an axios instance
const apiUrl = process.env.REACT_APP_API_URL;
const service = axios.create({
  baseURL: apiUrl, // url = base api url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000, // request timeout
  headers: {
    appid: APPID,
    version,
    'Content-Type': 'application/json',
  },
});

/** -2 并发时只走一次静默登录，避免重复弹窗 / reload */
let tokenExpiredHandler = null;

function isInitRequest(response) {
  try {
    const url = (response && response.config && response.config.url) || "";
    return url.includes("/User/init");
  } catch {
    return false;
  }
}

async function handleTokenExpired(response) {
  if (!tokenExpiredHandler) {
    tokenExpiredHandler = (async () => {
      const cfg = response.config;
      if (cfg && cfg.__retriedAfterTokenRefresh) {
        promptLoginFailReload();
        return;
      }
      try {
        const mainserviceMod = await import("./mainservice");
        // 清掉失效 token，再走匿名 init，才能拿到新 token
        try {
          localStorage.removeItem("my_token");
          mainserviceMod.setGlobalMyToken("");
        } catch (e) {}
        await mainserviceMod.default.loginFunSilentV2(true);
        window.dispatchEvent(new CustomEvent("auth-refreshed"));
        if (cfg && !cfg.__retriedAfterTokenRefresh) {
          await service.request({
            ...cfg,
            __retriedAfterTokenRefresh: true,
          });
        }
      } catch (e) {
        console.log("silent login after -2 failed", e);
        promptLoginFailReload();
      }
    })().finally(() => {
      tokenExpiredHandler = null;
    });
  }
  return tokenExpiredHandler;
}

// request拦截器 request interceptor
service.interceptors.request.use(
  (config) => {
    config.headers["token"] = getClientAuthToken();
    config.headers["channel"] = localStorage.getItem("channel") || channel;
    if (localStorage.getItem("my_source")) {
      config.headers["source"] = localStorage.getItem("my_source");
    }
    if (localStorage.getItem("my_language")) {
      config.headers["language"] = localStorage.getItem("my_language") || "";
    }
    if (localStorage.getItem("queryString")) {
      config.headers["querystring"] = localStorage.getItem("queryString") || "";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(
  (response) => {
    // let congUrl = response && response.config && response.config.url;
    const res = response.data || {};
    const { code, data, message } = res;
    if (code === 0 || code === '0') {
      return Promise.resolve(data || {});
    } else {
      const isTokenExpired = code === -2 || code === "-2";
      // 是否隐藏错误提示弹窗
      let hideToastCode = response && response.config && response.config.hideToastCode;
      let bolTipsDilg = response && response.config && response.config.hideToastDialg;
      if (hideToastCode && String(hideToastCode) === String(code)) {
        bolTipsDilg = true;
      }
      // -2 走静默登录，不弹通用错误框（避免与登录失败 Modal 叠两层）
      // isInitRequest 排除 init 接口，避免重复请求
      if (isTokenExpired && !isInitRequest(response)) {
        bolTipsDilg = true;
        void handleTokenExpired(response);
      } else if (!bolTipsDilg) {
        Dialog.alert({
          title: getStrFun("tip", "Tips"),
          content: message || getStrFun("errtips", "Something is wrong. Please retry later!"),
        });
      }
      return Promise.reject(res || "error");
    }
  },
  (error) => {
    console.log("err", error);
    if (error && error.config && error.config.ignoreErrors) {
      return Promise.resolve();
    }
    if (error && error.code === "ERR_NETWORK" && error.name === 'AxiosError') {
      error['message'] = getStrFun("networkError", "Network error. Please retry later!");
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default service;
